
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Forms/Date.html",
      function () {
        return require("private-next-pages/Forms/Date.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Forms/Date.html"])
      });
    }
  